export function isSebraeMG(): boolean {
  return window.location.hostname.includes("sebrae-mg");
}

export function isParaguayDomain(): boolean {
  return (
    window.location.hostname.includes("smartdocs.com.py") ||
    window.location.hostname.endsWith(".py")
  );
}

